import React, { Suspense, lazy } from 'react';
import Button from '@mui/material/Button';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { ExternalLinkIcon } from '../../assets';
import Loading from '../Loading';

const ProjectContent = lazy(() => import('./ProjectContent'));

const ProjectContainer = props => {
  console.log('ProjectContainer render');
  return (
    <div className="bg-dialog text-txt-primary flex flex-col justify-between h-[95dvh] lg:h-[98dvh]">
      <DialogTitle
        id="customized-dialog-title"
        className="bg-dialog-primary flex flex-row justify-between items-center !text-lg sm:!text-xl !px-5 sm:!px-4 !py-4" // sm:!p-4 !p-4
      >
        <div className="pl-2">{props.title}</div>
        <div className="">
          <IconButton
            aria-label="close"
            onClick={props.handleClose}
            className="!p-1.5 sm:!p-2"
            sx={{
              color: 'var(--text-primary)',
              backgroundColor: 'var(--dialog-secondary)',
            }}
          >
            <CloseIcon className="!h-5 !w-5" />
          </IconButton>
        </div>
      </DialogTitle>

      <Suspense fallback={<Loading />}>
        <ProjectContent {...props} />
      </Suspense>

      <DialogActions className="bg-dialog-primary">
        <div className="flex flex-wrap gap-2 px-4">
          <Button
            className="!px-4 !min-w-[100px] !normal-case !bg-dialog-secondary !text-txt-primary !text-base !py-2 !sm:py-3 !font-normal !rounded-lg"
            autoFocus
            onClick={props.handleClose}
          >
            Close
          </Button>
          <a className="" href={props.actionLink} target="_blank">
            <Button className="!w-full !px-4 !min-w-[100px] !normal-case !text-dialog-tertiary !bg-dialog-txt-primary !text-base !py-2 sm:!py-3 !rounded-lg">
              <div className="flex justify-center flex-row items-center gap-1.5">
                <div>{props.actionText}</div>
                {props.actionLink && <div className="w-6 h-6">
                  <ExternalLinkIcon className="stroke-dialog-tertiary fill-dialog-txt-primary w-full h-full" />
                </div>}
              </div>
            </Button>
          </a>
        </div>
      </DialogActions>
    </div>
  );
};
export default React.memo(ProjectContainer);
